import fetchHandler from "../../utils/fetchHandler";
import { ADD_RECIPE } from "../types/actions";

export const saveBasicDetails = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/recipes/`,
		method: "POST",
		actionType: ADD_RECIPE.SAVE_BASIC_DETAILS,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const publishRecipe = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/recipes/${id}`,
		method: "PATCH",
		actionType: ADD_RECIPE.PUBLISH_RECIPE,
		body: JSON.stringify({ active: "True" })
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const updateBasicDetails = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/recipes/${values.id}/`,
		method: "PUT",
		actionType: ADD_RECIPE.SAVE_BASIC_DETAILS,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const getRecipeIngredientList = (queryString) => {
	const fetchOptions = {
		url: `/api/recipe_ingredients/?limit=100&recipe=${queryString}`,
		method: "GET",
		actionType: ADD_RECIPE.GET_RECIPE_INGREDIENTS
	};

	return fetchHandler(fetchOptions);
};

export const addRecipeIngredients = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/recipe_ingredients/bulk_create/`,
		method: "POST",
		actionType: ADD_RECIPE.ADD_RECIPE_INGREDIENTS,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const updateRecipeIngredient = (id, values, successHandler) => {
	const fetchOptions = {
		url: `/api/recipe_ingredients/${id}/`,
		method: "PUT",
		actionType: ADD_RECIPE.UPDATE_RECIPE_INGREDIENTS,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const removeRecipeIngredient = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/recipe_ingredients/${id}`,
		method: "DELETE",
		actionType: ADD_RECIPE.DELETE_RECIPE_INGREDIENT
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const saveIngredients = (data) => {
	const fetchOptions = {
		url: "/api/recipe_ingredients",
		method: "POST",
		actionType: ADD_RECIPE.SAVE_INGREDIENTS,
		body: JSON.stringify(data)
	};

	return fetchHandler(fetchOptions);
};

export const saveCategories = (data) => {
	const fetchOptions = {
		url: "/api/recipe_categories",
		method: "POST",
		actionType: ADD_RECIPE.SAVE_CATEGORIES,
		body: JSON.stringify(data)
	};

	return fetchHandler(fetchOptions);
};

export const saveImages = (data) => {
	const fetchOptions = {
		url: "/api/recipe_images",
		method: "POST",
		actionType: ADD_RECIPE.SAVE_IMAGES,
		body: JSON.stringify(data)
	};

	return fetchHandler(fetchOptions);
};

export const saveSources = (data) => {
	const fetchOptions = {
		url: "/api/recipe_sources",
		method: "POST",
		actionType: ADD_RECIPE.SAVE_SOURCES,
		body: JSON.stringify(data)
	};

	return fetchHandler(fetchOptions);
};

export const addRecipeSources = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/recipe_sources/bulk_create/`,
		method: "POST",
		actionType: ADD_RECIPE.ADD_RECIPE_SOURCES,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const searchIngredients = (queryString) => {
	const fetchOptions = {
		url: `/api/food/search/?${queryString}`,
		method: "GET",
		actionType: ADD_RECIPE.SEARCH_INGREDIENTS
	};
	return fetchHandler(fetchOptions);
};

export const getCategories = (id) => {
	const fetchOptions = {
		url: `/api/categories${id ? `?group=${id}` : ''}`,
		method: "GET",
		actionType: ADD_RECIPE.GET_CATEGORIES
	};
	return fetchHandler(fetchOptions);
};

export const createCategory = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/categories`,
		method: "POST",
		actionType: ADD_RECIPE.CREATE_CATEGORY,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const updateCategory = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/categories/${values.id}`,
		method: "PATCH",
		actionType: ADD_RECIPE.UPDATE_CATEGORY,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const deleteCategory = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/categories/${id}`,
		method: "DELETE",
		actionType: ADD_RECIPE.DELETE_CATEGORY
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const getCategoryGroups = (search = false) => {
	const fetchOptions = {
		url: `/api/category_groups${search ? '?search=True' : ''}`,
		method: "GET",
		actionType: ADD_RECIPE.GET_CATEGORY_GROUPS
	};
	return fetchHandler(fetchOptions);
};

export const createCategoryGroup = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/category_groups`,
		method: "POST",
		actionType: ADD_RECIPE.CREATE_CATEGORY_GROUP,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const updateCategoryGroup = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/category_groups/${values.id}`,
		method: "PATCH",
		actionType: ADD_RECIPE.UPDATE_CATEGORY_GROUP,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const deleteCategoryGroup = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/category_groups/${id}`,
		method: "DELETE",
		actionType: ADD_RECIPE.DELETE_CATEGORY_GROUP
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const getRecipeCategoryList = (queryString) => {
	const fetchOptions = {
		url: `/api/recipe_categories/?recipe=${queryString}`,
		method: "GET",
		actionType: ADD_RECIPE.GET_RECIPE_CATEGORIES
	};
	return fetchHandler(fetchOptions);
};

export const addRecipeCategories = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/recipe_categories/bulk_create`,
		method: "POST",
		actionType: ADD_RECIPE.ADD_RECIPE_CATEGORY,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const removeRecipeCategory = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/recipe_categories/${id}`,
		method: "DELETE",
		actionType: ADD_RECIPE.DELETE_RECIPE_CATEGORY
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const getSources = () => {
	const fetchOptions = {
		url: `/api/sources/`,
		method: "GET",
		actionType: ADD_RECIPE.GET_SOURCES
	};
	return fetchHandler(fetchOptions);
};

export const createSource = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/sources`,
		method: "POST",
		actionType: ADD_RECIPE.CREATE_SOURCE,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const updateSource = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/sources/${values.id}`,
		method: "PATCH",
		actionType: ADD_RECIPE.UPDATE_SOURCE,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const deleteSource = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/sources/${id}`,
		method: "DELETE",
		actionType: ADD_RECIPE.DELETE_SOURCE
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const getRecipeSourceList = (queryString) => {
	const fetchOptions = {
		url: `/api/recipe_sources/?recipe_id=${queryString}`,
		method: "GET",
		actionType: ADD_RECIPE.GET_RECIPE_SOURCES
	};
	return fetchHandler(fetchOptions);
};

export const removeRecipeSource = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/recipe_sources/${id}`,
		method: "DELETE",
		actionType: ADD_RECIPE.DELETE_RECIPE_SOURCE
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const getImages = (queryString) => {
	const fetchOptions = {
		url: `/api/images/?${queryString}`,
		method: "GET",
		actionType: ADD_RECIPE.GET_IMAGES
	};
	return fetchHandler(fetchOptions);
};

export const addImages = (data, successHandler) => {
	const fetchOptions = {
		url: `/api/images/`,
		method: "POST",
		actionType: ADD_RECIPE.ADD_IMAGES,
		body: data,
		isFileUpload: true
	};
	return fetchHandler(fetchOptions, successHandler);
};

export const addRecipeImages = (values, successHandler) => {
	const fetchOptions = {
		url: `/api/recipe_images/bulk_create/`,
		method: "POST",
		actionType: ADD_RECIPE.ADD_RECIPE_IMAGES,
		body: JSON.stringify(values)
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const getRecipeImageList = (queryString) => {
	const fetchOptions = {
		url: `/api/recipe_images/?recipe=${queryString}`,
		method: "GET",
		actionType: ADD_RECIPE.GET_RECIPE_IMAGES
	};
	return fetchHandler(fetchOptions);
};

export const removeRecipeImages = (id, successHandler) => {
	const fetchOptions = {
		url: `/api/recipe_images/${id}`,
		method: "DELETE",
		actionType: ADD_RECIPE.DELETE_RECIPE_IMAGE
	};

	return fetchHandler(fetchOptions, successHandler);
};

export const getFoodGroupList = () => {
	const fetchOptions = {
		url: `/api/hier1`,
		method: "GET",
		actionType: ADD_RECIPE.GET_FOOD_GROUP_LIST
	};
	return fetchHandler(fetchOptions);
};

export const getIngredientWeightsList = (id) => {
	const fetchOptions = {
		url: `/api/ingredient_weights/?food=${id}`,
		method: "GET",
		actionType: ADD_RECIPE.GET_INGREDIENT_WEIGHTS_LIST
	};
	return fetchHandler(fetchOptions);
};

export const submitUserRecipe = (values, successHandler, errorHandler) => {
	const fetchOptions = {
		url: `/api/recipe_submissions`,
		method: "POST",
		actionType: ADD_RECIPE.SUBMIT_RECIPE,
		body: values,
		isFileUpload: true
	};
	return fetchHandler(fetchOptions, successHandler, errorHandler);
};
